'use client';

import { useUserStore } from '@/core/stores/user';
import useNextRouter from '@/hooks/useNextRouter';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import Link from 'next/link';

const NavigateButton = ({ to, children, actionMessage, ...props }: any) => {
    const router = useNextRouter();
    const { addActions } = useUserStore()

    const { params } = useSetSearchParams()
    const searchQuery = new URLSearchParams(params).toString();

    const queryString = searchQuery ? `?${searchQuery}` : '';
    // const handleClick = () => {
    //     actionMessage && addActions({ type: 'click', message: actionMessage })
    // };

    return (
        <Link href={`${to}${queryString}`}  {...props}>
            {children}
        </Link>
    );
};

export default NavigateButton;
